const locale = {
  'Invite generated': 'Invite generated',
  'This token will be shown only once': 'This token will be shown only once',
  'Copy it now and send it through a secure channel. It is single-use and we store only its hash — if lost, revoke it and generate another.': 'Copy it now and send it through a secure channel. It is single-use and we store only its hash — if lost, revoke it and generate another.',
  'Copy token': 'Copy token',
  'Copied': 'Copied',
  'Expires in': 'Expires in',
  'Expired': 'Expired',
  'This token expired. Generate another invite to connect this partner.': 'This token expired. Generate another invite to connect this partner.',
  'Contract': 'Contract',
  'Bidirectional — both apps display': 'Bidirectional — both apps display',
  'One-way — only their app displays': 'One-way — only their app displays',
  'Use': 'Use',
  'Single use · stored only as a hash': 'Single use · stored only as a hash',
  'inherits new ones': 'inherits new ones',
  'Download QR art': 'Download QR art',
  'Token copied.': 'Token copied.',
  'Did you copy the token? It cannot be recovered.': 'Did you copy the token? It cannot be recovered.',
  'Close': 'Close',
  'I copied it, close': 'I copied it, close',
  'Invited tenant': 'Invited tenant',
  'Select a tenant': 'Select a tenant',
  'Contact e-mail': 'Contact e-mail',
  'Accounts in the contract': 'Accounts in the contract',
  'sharing always covers every station of the account': 'sharing always covers every station of the account',
  'All accounts': 'All accounts',
  'All except...': 'All except...',
  'Select accounts': 'Select accounts',
  'All accounts included — nothing to filter': 'All accounts included — nothing to filter',
  'Search sub-account by name': 'Search sub-account by name',
  'No sub-account with that name': 'No sub-account with that name',
  'select all': 'select all',
  'clear exclusions': 'clear exclusions',
  'Parent account always included': 'Parent account always included',
  'sub-accounts included automatically': 'sub-accounts included automatically',
  'out of the contract': 'out of the contract',
  'sub-accounts marked': 'sub-accounts marked',
  'accounts': 'accounts',
  'Automatically include new sub-accounts': 'Automatically include new sub-accounts',
  'Visibility contract type': 'Visibility contract type',
  'This tenant has an app configured — it can receive stations, so the bidirectional contract is available.': 'This tenant has an app configured — it can receive stations, so the bidirectional contract is available.',
  'This tenant has no app configured: it does not receive stations. Only the one-way contract is possible.': 'This tenant has no app configured: it does not receive stations. Only the one-way contract is possible.',
  'Token validity': 'Token validity',
  '* Required fields. The partner only sees your network after entering the token.': '* Required fields. The partner only sees your network after entering the token.',
  'Cancel': 'Cancel',
  'Generate invite': 'Generate invite',
  'Could not generate the invite. Try again.': 'Could not generate the invite. Try again.',
  'Accounts of my hierarchy in this contract': 'Accounts of my hierarchy in this contract',
  'Pending changes: {0} entering, {1} leaving': 'Pending changes: {0} entering, {1} leaving',
  'Apply the new contract scope?': 'Apply the new contract scope?',
  'These accounts, and any sub-accounts below them, stop being displayed to the partner right away: {0}. The contract stays active.': 'These accounts, and any sub-accounts below them, stop being displayed to the partner right away: {0}. The contract stays active.',
  'The marked accounts start being displayed to the partner. The contract stays active.': 'The marked accounts start being displayed to the partner. The contract stays active.',
  'Apply': 'Apply',
  'Apply scope': 'Apply scope',
  'Applying...': 'Applying...',
  'Undo': 'Undo',
  'will be added': 'will be added',
  'will be removed': 'will be removed',
  'The parent account cannot leave the contract.': 'The parent account cannot leave the contract.',
  'Contract scope updated.': 'Contract scope updated.',
  'Could not change the scope now. Nothing was changed.': 'Could not change the scope now. Nothing was changed.',
  'parent account': 'parent account',
  'sub-account': 'sub-account',
  'stations': 'stations',
  'Loading...': 'Loading...',
  'Could not load the accounts of this contract.': 'Could not load the accounts of this contract.',
  'New sub-accounts join this contract automatically — no new invite.': 'New sub-accounts join this contract automatically — no new invite.',
  'New sub-accounts do NOT join automatically: each inclusion is an explicit action.': 'New sub-accounts do NOT join automatically: each inclusion is an explicit action.',
  'app configured': 'app configured',
  'no app': 'no app',
  'Bidirectional': 'Bidirectional',
  'One-way': 'One-way',
  'Ativo': 'Active',
  'Convite pendente': 'Pending invite',
  'Suspenso': 'Suspended',
  'Revogado': 'Revoked',
  'Suspend': 'Suspend',
  'Reactivate': 'Reactivate',
  'Revoke': 'Revoke',
  'You have no connected partners yet': 'You have no connected partners yet',
  'I have an invite token': 'I have an invite token',
  'Show or hide these stations in my app': 'Show or hide these stations in my app',
  'Revoking ends this contract. Reconnecting requires a new invite. Continue?': 'Revoking ends this contract. Reconnecting requires a new invite. Continue?',
  'A contract is only bidirectional when both tenants have an app configured — without an app the partner can share stations but receives none. Turning receiving on or off does not change the contract: it only hides the partner stations in your app.': 'A contract is only bidirectional when both tenants have an app configured — without an app the partner can share stations but receives none. Turning receiving on or off does not change the contract: it only hides the partner stations in your app.',
  'Interoperability': 'Interoperability',
  'Connections': 'Connections',
  'Connection map': 'Connection map',
  'Transactions': 'Transactions',
  'History': 'History',
  'Invite partner': 'Invite partner',
  'Enter token': 'Enter token',
  'Review invite': 'Review invite',
  'Each accepted invite creates a station visibility contract — bidirectional or one-way.': 'Each accepted invite creates a station visibility contract — bidirectional or one-way.',
  'wants your app to display their stations': 'wants your app to display their stations',
  'invite(s) sent awaiting acceptance': 'invite(s) sent awaiting acceptance',
  'Could not load interoperability data. Try again.': 'Could not load interoperability data. Try again.',
  'Accept invite': 'Accept invite',
  'Paste the token your partner sent you': 'Paste the token your partner sent you',
  'Paste the token sent by': 'Paste the token sent by',
  'Validate': 'Validate',
  'Single-use and time-limited. The token never appears in the URL — up to 5 attempts.': 'Single-use and time-limited. The token never appears in the URL — up to 5 attempts.',
  'Valid token': 'Valid token',
  'Bidirectional contract': 'Bidirectional contract',
  'One-way contract': 'One-way contract',
  'both sides display each other stations': 'both sides display each other stations',
  'only your app starts displaying stations': 'only your app starts displaying stations',
  'Your app starts displaying': 'Your app starts displaying',
  'from': 'from',
  'account(s)': 'account(s)',
  'starts displaying': 'starts displaying',
  'of your stations': 'of your stations',
  'I authorize the sharing described above': 'I authorize the sharing described above',
  'Connect': 'Connect',
  'Connected with': 'Connected with',
  'The token was invalidated and cannot be used again. The contract is now active and the stations are already in your combined network.': 'The token was invalidated and cannot be used again. The contract is now active and the stations are already in your combined network.',
  'expires in': 'expires in',
  'no longer valid': 'no longer valid',
  'expired': 'expired',
  'This token expired on': 'This token expired on',
  'Ask your partner for a new one.': 'Ask your partner for a new one.',
  'This token has expired.': 'This token has expired.',
  'This token was already used on': 'This token was already used on',
  'This token was already used.': 'This token was already used.',
  'This invite was cancelled by whoever sent it.': 'This invite was cancelled by whoever sent it.',
  'Too many attempts. Wait a few minutes before trying again.': 'Too many attempts. Wait a few minutes before trying again.',
  'This is an account token, not an invite token.': 'This is an account token, not an invite token.',
  'The invite token is the one your partner generates for you.': 'The invite token is the one your partner generates for you.',
  'This is an invite token, not an account token.': 'This is an invite token, not an account token.',
  'Ask your partner for the token of their account.': 'Ask your partner for the token of their account.',
  'Account token generated': 'Account token generated',
  'Account token renewed': 'Account token renewed',
  'Invites': 'Invites',
  'Direction': 'Direction',
  'Sent': 'Sent',
  'Received': 'Received',
  'Deadline': 'Deadline',
  'Pending': 'Pending',
  'Accepted': 'Accepted',
  'accepted': 'accepted',
  'accepted on': 'accepted on',
  'expired on': 'expired on',
  'Revoked': 'Revoked',
  'revoked': 'revoked',
  'Revoke this invite?': 'Revoke this invite?',
  'The token stops working immediately and': 'The token stops working immediately and',
  'will no longer be able to accept it. To connect later you have to send a new invite.': 'will no longer be able to accept it. To connect later you have to send a new invite.',
  'the partner': 'the partner',
  'Invite revoked.': 'Invite revoked.',
  'Could not revoke the invite. Nothing was changed.': 'Could not revoke the invite. Nothing was changed.',
  'Could not load the invites.': 'Could not load the invites.',
  'No invites yet. Invite a partner to get started.': 'No invites yet. Invite a partner to get started.',
  'Only whoever sent an invite can revoke it.': 'Only whoever sent an invite can revoke it.',
  'invites': 'invites',
  'Integrations': 'Integrations',
  'Integrator': 'Integrator',
  'Scopes': 'Scopes',
  'Last use': 'Last use',
  'never used': 'never used',
  'Active': 'Active',
  'Validity': 'Validity',
  'New token': 'New token',
  'New integration token': 'New integration token',
  'Create token': 'Create token',
  'Creating...': 'Creating...',
  'Integration token created': 'Integration token created',
  'Read data': 'Read data',
  'Operate charging': 'Operate charging',
  'Manage contracts': 'Manage contracts',
  'sensitive': 'sensitive',
  'Query connections, cross charges, history and contract stations.': 'Query connections, cross charges, history and contract stations.',
  'Start and stop charging on the stations this contract reaches. This is the only scope with a physical effect.': 'Start and stop charging on the stations this contract reaches. This is the only scope with a physical effect.',
  'Generate invites, accept, revoke and change scope. A compromised integrator can open your network to a third party.': 'Generate invites, accept, revoke and change scope. A compromised integrator can open your network to a third party.',
  'Who is this integrator?': 'Who is this integrator?',
  'Billing ACME, BI dashboard, partner app...': 'Billing ACME, BI dashboard, partner app...',
  'This name is how you will recognize the token later, to revoke it.': 'This name is how you will recognize the token later, to revoke it.',
  'What can this token do?': 'What can this token do?',
  'Nothing is granted by default: mark only what the integrator needs.': 'Nothing is granted by default: mark only what the integrator needs.',
  'Leave empty for a token that does not expire.': 'Leave empty for a token that does not expire.',
  'The token is shown once, right after creation.': 'The token is shown once, right after creation.',
  'This token will be shown only once.': 'This token will be shown only once.',
  'Send it to the integrator through a secure channel. We store only a hash — if it is lost, revoke it and create another.': 'Send it to the integrator through a secure channel. We store only a hash — if it is lost, revoke it and create another.',
  'Revoke this token?': 'Revoke this token?',
  'The integration of': 'The integration of',
  'stops working immediately. To restore it you have to create another token and configure it on their side.': 'stops working immediately. To restore it you have to create another token and configure it on their side.',
  'Token revoked.': 'Token revoked.',
  'Delete': 'Delete',
  'Delete this revoked token?': 'Delete this revoked token?',
  'Token deleted.': 'Token deleted.',
  'Could not delete the token. Nothing was changed.': 'Could not delete the token. Nothing was changed.',
  'The token': 'The token',
  'is removed for good. This cannot be undone; the audit trail keeps the record.': 'is removed for good. This cannot be undone; the audit trail keeps the record.',
  'Delete removes this revoked token for good — the audit trail keeps the record.': 'Delete removes this revoked token for good — the audit trail keeps the record.',
  'Delete this revoked connection?': 'Delete this revoked connection?',
  'Deleting removes the contract for good. This cannot be undone; the audit trail keeps the record.': 'Deleting removes the contract for good. This cannot be undone; the audit trail keeps the record.',
  'Connection deleted.': 'Connection deleted.',
  '180 days': '180 days',
  '1 year': '1 year',
  'Enable all': 'Enable all',
  'Discard': 'Discard',
  'Enable': 'Enable',
  'Enable eligibility for these accounts?': 'Enable eligibility for these accounts?',
  'Enabling an account shares its stations and charges with the cross network. Turn on only what should be visible to partners.': 'Enabling an account shares its stations and charges with the cross network. Turn on only what should be visible to partners.',
  'No accounts to show.': 'No accounts to show.',
  'Not shared': 'Not shared',
  'This shares their data with the cross network:': 'This shares their data with the cross network:',
  'to disable': 'to disable',
  'to enable': 'to enable',
  'will be turned off.': 'will be turned off.',
  'Eligibility enabled': 'Eligibility enabled',
  'Eligibility disabled': 'Eligibility disabled',
  'Children': 'Children',
  'Clear all': 'Clear all',
  'Search account by name': 'Search account by name',
  'No account matches this search.': 'No account matches this search.',
  'Applies to every account on this level, including the other pages.': 'Applies to every account on this level, including the other pages.',
  'not shown (other company)': 'not shown (other company)',
  'not recorded': 'not recorded',
  'Could not load the accounts.': 'Could not load the accounts.',
  'Could not update eligibility. Nothing was changed.': 'Could not update eligibility. Nothing was changed.',
  'Eligibility': 'Eligibility',
  'Eligibility updated.': 'Eligibility updated.',
  'Enable which accounts can take part in interoperability. Enabling replicates that account stations and charges to the cross network — turn on only what should be shared.': 'Enable which accounts can take part in interoperability. Enabling replicates that account stations and charges to the cross network — turn on only what should be shared.',
  'Grandchildren': 'Grandchildren',
  'Interoperability eligibility': 'Interoperability eligibility',
  'Level': 'Level',
  'No changes to save.': 'No changes to save.',
  'No pending changes.': 'No pending changes.',
  'Save changes': 'Save changes',
  'Saving…': 'Saving…',
  'Select all': 'Select all',
  'This account': 'This account',
  'pending changes': 'pending changes',
  'Delete removes this revoked invite for good — the audit trail keeps the record.': 'Delete removes this revoked invite for good — the audit trail keeps the record.',
  'Delete this revoked invite?': 'Delete this revoked invite?',
  'The invite is removed for good. This cannot be undone; the audit trail keeps the record.': 'The invite is removed for good. This cannot be undone; the audit trail keeps the record.',
  'Invite deleted.': 'Invite deleted.',
  'Could not delete the invite. Nothing was changed.': 'Could not delete the invite. Nothing was changed.',
  '(defaults to the current tenant)': '(defaults to the current tenant)',
  '(empty response)': '(empty response)',
  'API documentation sections': 'API documentation sections',
  'Body': 'Body',
  'Documentation': 'Documentation',
  'Filter by method, path or description': 'Filter by method, path or description',
  'Filter endpoints': 'Filter endpoints',
  'Guide': 'Guide',
  'Hide Try it': 'Hide Try it',
  'How your integrators authenticate and what the API offers. The Postman collection carries the same endpoints.': 'How your integrators authenticate and what the API offers. The Postman collection carries the same endpoints.',
  'In': 'In',
  'Integration token (Bearer) — not stored': 'Integration token (Bearer) — not stored',
  'Internal API': 'Internal API',
  'Internal tenant-cross endpoints, generated from the backend. They authenticate by tenant identity or session, not by the integration token.': 'Internal tenant-cross endpoints, generated from the backend. They authenticate by tenant identity or session, not by the integration token.',
  'No endpoint matches this search.': 'No endpoint matches this search.',
  'Parameters': 'Parameters',
  'Partner API': 'Partner API',
  'Request body': 'Request body',
  'Send': 'Send',
  'Sending…': 'Sending…',
  'The integration endpoints, authenticated by the integration token.': 'The integration endpoints, authenticated by the integration token.',
  'Tokens': 'Tokens',
  'Try it': 'Try it',
  'current tenant': 'current tenant',
  'endpoints': 'endpoints',
  'path': 'path',
  'query': 'query',
  'Could not revoke the token. Nothing was changed.': 'Could not revoke the token. Nothing was changed.',
  'Could not create the token.': 'Could not create the token.',
  'Could not create the token now. Try again in a moment.': 'Could not create the token now. Try again in a moment.',
  'Could not load the integration tokens.': 'Could not load the integration tokens.',
  'No integration tokens yet. Create one to give an integrator access.': 'No integration tokens yet. Create one to give an integrator access.',
  'Tokens your integrators use to operate in your name. Each one carries only the scopes you grant, is shown once at creation, and can be revoked at any time.': 'Tokens your integrators use to operate in your name. Each one carries only the scopes you grant, is shown once at creation, and can be revoked at any time.',
  'A token is never shown again after creation — if one is lost, revoke it and create another.': 'A token is never shown again after creation — if one is lost, revoke it and create another.',
  'Token': 'Token',
  'not identified': 'not identified',
  'Renew this token?': 'Renew this token?',
  'The current secret stops working immediately and': 'The current secret stops working immediately and',
  'will need the new one. Name and scopes stay the same.': 'will need the new one. Name and scopes stay the same.',
  'Token renewed.': 'Token renewed.',
  'Could not renew the token. Nothing was changed.': 'Could not renew the token. Nothing was changed.',
  'Extend validity': 'Extend validity',
  'Extend this token?': 'Extend this token?',
  'The same secret goes back to working, with no expiry date.': 'The same secret goes back to working, with no expiry date.',
  'It was never compromised — it only aged out.': 'It was never compromised — it only aged out.',
  'Validity extended.': 'Validity extended.',
  'Could not extend the validity. Nothing was changed.': 'Could not extend the validity. Nothing was changed.',
  'Recreate': 'Recreate',
  'Create a new token like this one?': 'Create a new token like this one?',
  'A new token is created with the same name and scopes.': 'A new token is created with the same name and scopes.',
  'The revoked one stays revoked in the list — the old secret never comes back.': 'The revoked one stays revoked in the list — the old secret never comes back.',
  'Token recreated.': 'Token recreated.',
  'Could not recreate the token. Nothing was changed.': 'Could not recreate the token. Nothing was changed.',
  'Representative e-mail': 'Representative e-mail',
  'optional': 'optional',
  'Who to contact when the integration breaks. Recorded in the module history.': 'Who to contact when the integration breaks. Recorded in the module history.',
  'The token is never sent by e-mail.': 'The token is never sent by e-mail.',
  'Search integrator, e-mail or token': 'Search integrator, e-mail or token',
  'All states': 'All states',
  'Any scope': 'Any scope',
  'tokens': 'tokens',
  'of': 'of',
  'No token matches these filters.': 'No token matches these filters.',
  'Actions': 'Actions',
  'Granted': 'Granted',
  'Created by': 'Created by',
  'Last renewal': 'Last renewal',
  'Revoked on': 'Revoked on',
  'The full value is never shown again — only these last characters identify it.': 'The full value is never shown again — only these last characters identify it.',
  'Creates a new token with the same name and scopes. This one stays revoked, and its secret never comes back.': 'Creates a new token with the same name and scopes. This one stays revoked, and its secret never comes back.',
  'Expired, not compromised: extending brings the same secret back, so the integrator does not have to change anything.': 'Expired, not compromised: extending brings the same secret back, so the integrator does not have to change anything.',
  'Renewing swaps the secret and keeps name and scopes — the integrator has to be given the new value. Revoking ends this access for good.': 'Renewing swaps the secret and keeps name and scopes — the integrator has to be given the new value. Revoking ends this access for good.',
  'API': 'API',
  'Download Postman collection': 'Download Postman collection',
  'How to integrate': 'How to integrate',
  'This API exposes what this account shares through interoperability contracts. An integrator authenticates with a token you create here, and sees only what the token scopes allow.': 'This API exposes what this account shares through interoperability contracts. An integrator authenticates with a token you create here, and sees only what the token scopes allow.',
  'Create a token with the scopes the integrator needs': 'Create a token with the scopes the integrator needs',
  'Use "New token" above. Nothing is granted by default — mark only what they need. The value appears once, right after creation, and is never shown again.': 'Use "New token" above. Nothing is granted by default — mark only what they need. The value appears once, right after creation, and is never shown again.',
  'Send the token on every request': 'Send the token on every request',
  'The token goes in the': 'The token goes in the',
  'header, never in the URL — a URL ends up in browser history and proxy logs.': 'header, never in the URL — a URL ends up in browser history and proxy logs.',
  'The base address of this environment is': 'The base address of this environment is',
  'Note there is no tenant in the path: the token itself says which account it is.': 'Note there is no tenant in the path: the token itself says which account it is.',
  'Handle the refusals': 'Handle the refusals',
  'means the token is missing, revoked or expired.': 'means the token is missing, revoked or expired.',
  'means the token is valid but lacks a scope this endpoint requires — ask for a token with that scope instead of retrying.': 'means the token is valid but lacks a scope this endpoint requires — ask for a token with that scope instead of retrying.',
  'means something in the request is wrong.': 'means something in the request is wrong.',
  'Rotate when needed': 'Rotate when needed',
  'A lost token cannot be recovered — open its details and use Renew, which keeps the name and scopes and swaps the secret. Revoking ends the access for good.': 'A lost token cannot be recovered — open its details and use Renew, which keeps the name and scopes and swaps the secret. Revoking ends the access for good.',
  'What each scope unlocks. They are independent: one does not imply another.': 'What each scope unlocks. They are independent: one does not imply another.',
  'Endpoints': 'Endpoints',
  'Everything the integration API offers today.': 'Everything the integration API offers today.',
  'The same list is in the Postman collection you can download above.': 'The same list is in the Postman collection you can download above.',
  'Parameter': 'Parameter',
  'Description': 'Description',
  'Example': 'Example',
  'Response': 'Response',
  'Search partner by name or alias': 'Search partner by name or alias',
  'All statuses': 'All statuses',
  'Pending invite': 'Pending invite',
  'Suspended': 'Suspended',
  'Any contract': 'Any contract',
  'Only the ones I receive from': 'Only the ones I receive from',
  'connections': 'connections',
  'No connection matches these filters.': 'No connection matches these filters.',
  'Both directions': 'Both directions',
  'No invite matches these filters.': 'No invite matches these filters.',
  'Both apps display the other stations': 'Both apps display the other stations',
  'Only your app displays the partner stations': 'Only your app displays the partner stations',
  'Only the partner app displays your stations': 'Only the partner app displays your stations',
  'Any problem': 'Any problem',
  'Available stations': 'Available stations',
  'Connectors': 'Connectors',
  'Coordinates': 'Coordinates',
  'Correct': 'Correct',
  'Could not load the stations.': 'Could not load the stations.',
  'Details': 'Details',
  'Disabled': 'Disabled',
  'Enabled': 'Enabled',
  'Identifier': 'Identifier',
  'It does not show up in the catalogue the partner reads.': 'It does not show up in the catalogue the partner reads.',
  'It has never reported since it was registered — different from being offline now.': 'It has never reported since it was registered — different from being offline now.',
  'Last signal': 'Last signal',
  'Location': 'Location',
  'Name': 'Name',
  'Never connected': 'Never connected',
  'No': 'No',
  'No address': 'No address',
  'No connector': 'No connector',
  'No coordinates': 'No coordinates',
  'No station matches this filter.': 'No station matches this filter.',
  'No tariff': 'No tariff',
  'Nothing: this station is correctly registered.': 'Nothing: this station is correctly registered.',
  'Number': 'Number',
  'Offline': 'Offline',
  'Online': 'Online',
  'Owner account': 'Owner account',
  'Partners': 'Partners',
  'Registration': 'Registration',
  'Registration data': 'Registration data',
  'Search by name or number': 'Search by name or number',
  'Stations': 'Stations',
  'Status now': 'Status now',
  'The partner app searches by radius, so the station never appears in the results.': 'The partner app searches by radius, so the station never appears in the results.',
  'The partner displays the station without saying where it is.': 'The partner displays the station without saying where it is.',
  'The partner does not know the price it will charge its own user.': 'The partner does not know the price it will charge its own user.',
  'There is nothing to start: the partner user cannot charge here.': 'There is nothing to start: the partner user cannot charge here.',
  'What is wrong': 'What is wrong',
  'Yes': 'Yes',
  'connectors': 'connectors',
  'never': 'never',
  'no address': 'no address',
  'none': 'none',
  'Created': 'Created',
  'Every station reached by an active contract, in both directions, with the contract it belongs to and what would reach the partner broken.': 'Every station reached by an active contract, in both directions, with the contract it belongs to and what would reach the partner broken.',
  'Accepted at': 'Accepted at',
  'Accepted by': 'Accepted by',
  'Accounts in scope': 'Accounts in scope',
  'Author': 'Author',
  'Detail': 'Detail',
  'Ended at': 'Ended at',
  'Expires at': 'Expires at',
  'Generated by': 'Generated by',
  'IP': 'IP',
  'Includes new sub-accounts': 'Includes new sub-accounts',
  'Invite': 'Invite',
  'Numbers': 'Numbers',
  'OCPP code': 'OCPP code',
  'Origin': 'Origin',
  'Started at': 'Started at',
  'Trail': 'Trail',
  'User': 'User',
  'The token is shown only once, when the invite is generated: it is stored as a hash and cannot be displayed again. To hand it over once more, generate a new invite.': 'The token is shown only once, when the invite is generated: it is stored as a hash and cannot be displayed again. To hand it over once more, generate a new invite.',
  'Could not load the connectors.': 'Could not load the connectors.',
  'List': 'List',
  'Map': 'Map',
  'No station in this filter has coordinates to show on the map.': 'No station in this filter has coordinates to show on the map.',
  'Open details': 'Open details',
  'Ready for the partner': 'Ready for the partner',
  'See only those': 'See only those',
  'Showing the first': 'Showing the first',
  'The partner cannot use it': 'The partner cannot use it',
  'This station has no connector registered.': 'This station has no connector registered.',
  'Usable, with wrong data': 'Usable, with wrong data',
  'never reported': 'never reported',
  'no own tariff': 'no own tariff',
  'no power': 'no power',
  'no type': 'no type',
  'of the filtered stations have no coordinates and do not appear on the map.': 'of the filtered stations have no coordinates and do not appear on the map.',
  'own tariff': 'own tariff',
  'stations in this filter.': 'stations in this filter.',
  'Available': 'Available',
  'Preparing': 'Preparing',
  'Charging': 'Charging',
  'Suspended by the vehicle': 'Suspended by the vehicle',
  'Suspended by the station': 'Suspended by the station',
  'Finishing': 'Finishing',
  'Reserved': 'Reserved',
  'Faulted': 'Faulted',
  'Charging group full': 'Power unavailable',
  'Unavailable': 'Unavailable',
  'Most stations in': 'Most stations in',
  'Fewer stations': 'Fewer stations',
  'More stations': 'More stations',
  'on the map without an address': 'on the map without an address',
  'The map could not be drawn. The rest of the screen keeps working.': 'The map could not be drawn. The rest of the screen keeps working.',
  'Density': 'Density',
  'The density layer failed:': 'The density layer failed:',
  'Points': 'Points',
  'with problems': 'with problems',
  'No registration problem in this filter.': 'No registration problem in this filter.',
  'Nothing missing: the partner can use these.': 'Nothing missing: the partner can use these.',
  'Registration status': 'Registration status',
  'Clear filter': 'Clear filter',
  'filtering by': 'filtering by',
  'Audit': 'Audit',
  'Contracts': 'Contracts',
  'Diagram': 'Diagram',
  'Only available on an effective contract where you receive stations': 'Only available on an effective contract where you receive stations',
  'Invalid token. Check whether you copied the whole code.': 'Invalid token. Check whether you copied the whole code.',
  'Could not check the token now. Try again in a moment.': 'Could not check the token now. Try again in a moment.',
  'Could not accept the invite now. Try again in a moment.': 'Could not accept the invite now. Try again in a moment.',
  'wants your app to display': 'wants your app to display',
  'All partners': 'All partners',
  'Could not download the CSV. The list on screen is unchanged.': 'Could not download the CSV. The list on screen is unchanged.',
  'Download CSV': 'Download CSV',
  'Preparing...': 'Preparing...',
  'Could not load the charges. Try again.': 'Could not load the charges. Try again.',
  'No cross charges in this period.': 'No cross charges in this period.',
  'Charge': 'Charge',
  'Station': 'Station',
  'Connector': 'Connector',
  'Origin tenant': 'Origin tenant',
  'User (Tag)': 'User (Tag)',
  'Start - End': 'Start - End',
  'Duration': 'Duration',
  'Energy (kWh)': 'Energy (kWh)',
  'Revenue': 'Revenue',
  'Payment': 'Payment',
  'in progress': 'in progress',
  'Charging...': 'Charging...',
  'Totals for the filtered period': 'Totals for the filtered period',
  'Charges': 'Charges',
  'Energy': 'Energy',
  'To invoice': 'To invoice',
  'Users from other tenants are always masked': 'Users from other tenants are always masked',
  'Page': 'Page',
  'charges': 'charges',
  'Previous': 'Previous',
  'Next': 'Next',
  'Submit': 'Submit',
  'Station no longer registered': 'Station no longer registered',
  'Invite revoked': 'Invite revoked',
  'Invite expired': 'Invite expired',
  'Token used': 'Token used',
  'Invalid token attempt': 'Invalid token attempt',
  'Scope changed': 'Scope changed',
  'Subaccount included automatically': 'Subaccount included automatically',
  'Connection suspended': 'Connection suspended',
  'Connection reactivated': 'Connection reactivated',
  'Connection revoked': 'Connection revoked',
  'Success': 'Success',
  'Blocked': 'Blocked',
  'Failure': 'Failure',
  'All events': 'All events',
  'Could not load the history. Try again.': 'Could not load the history. Try again.',
  'No events in this period.': 'No events in this period.',
  'Date / time': 'Date / time',
  'Event': 'Event',
  'Responsible': 'Responsible',
  'Partner': 'Partner',
  'Result': 'Result',
  'no human author': 'no human author',
  'unnamed tenant': 'unnamed tenant',
  'unknown': 'unknown',
  'attempt': 'attempt',
  'Read-only trail: events cannot be edited or deleted.': 'Read-only trail: events cannot be edited or deleted.',
  'events': 'events',
  'My hierarchy → partners': 'My hierarchy → partners',
  'Flow': 'Flow',
  'Mind map': 'Mind map',
  'Mind map: your head account at the center, subaccounts on the left, partners around. Solid arrow = I share; dashed arrow back = I receive.': 'Mind map: your head account at the center, subaccounts on the left, partners around. Solid arrow = I share; dashed arrow back = I receive.',
  'Showing only the selected partner links — click it again to see all.': 'Showing only the selected partner links — click it again to see all.',
  'Click a partner on the right to isolate its links.': 'Click a partner on the right to isolate its links.',
  'Could not load the map. Try again.': 'Could not load the map. Try again.',
  'No contracts or open invites to draw yet.': 'No contracts or open invites to draw yet.',
  'MY ACCOUNTS': 'MY ACCOUNTS',
  'PARTNERS': 'PARTNERS',
  'head account': 'head account',
  'subaccount': 'subaccount',
  'Active bidirectional contract — both apps display': 'Active bidirectional contract — both apps display',
  'Active one-way contract — only the partner displays': 'Active one-way contract — only the partner displays',
  'Pending invite — nothing shared yet': 'Pending invite — nothing shared yet',
  'Suspended — contract stands, nothing displayed': 'Suspended — contract stands, nothing displayed',
  'Last session': 'Last session',
  'Partner app': 'Partner app',
  'Show these stations in my app': 'Show these stations in my app',
  'Stations I receive': 'Stations I receive',
  'Stations I share': 'Stations I share',
  'Status': 'Status',
  'Type': 'Type',
  'Without an app the partner can share stations but receives none, so the contract cannot be bidirectional.': 'Without an app the partner can share stations but receives none, so the contract cannot be bidirectional.',
  'Partner accounts in this contract': 'Partner accounts in this contract',
  'Your account token': 'Your account token',
  'Hand this token to a partner so they can invite your account. Whoever has it can only invite you — accepting is still your decision.': 'Hand this token to a partner so they can invite your account. Whoever has it can only invite you — accepting is still your decision.',
  'Could not load the token. Try again.': 'Could not load the token. Try again.',
  'This account has no token yet.': 'This account has no token yet.',
  'Copy': 'Copy',
  'Expired on': 'Expired on',
  'renew to share again': 'renew to share again',
  'Valid until': 'Valid until',
  'Does not expire': 'Does not expire',
  'renewed on': 'renewed on',
  'does not expire': 'does not expire',
  '7 days': '7 days',
  '30 days': '30 days',
  '90 days': '90 days',
  'Renew': 'Renew',
  'Generate token': 'Generate token',
  'Renewing invalidates the current token.': 'Renewing invalidates the current token.',
  'Renewing invalidates the current token: partners who have it can no longer invite you. Continue?': 'Renewing invalidates the current token: partners who have it can no longer invite you. Continue?',
  'Open contract': 'Open contract',
  'Partner account token': 'Partner account token',
  'Check': 'Check',
  'Checking...': 'Checking...',
  'Ask the partner for the token shown on their Interoperability screen.': 'Ask the partner for the token shown on their Interoperability screen.',
  'Could not check this token now. Try again in a moment.': 'Could not check this token now. Try again in a moment.',
  'The current token could not be read. Generating a new one invalidates whatever token exists, and partners holding it will no longer be able to invite you.': 'The current token could not be read. Generating a new one invalidates whatever token exists, and partners holding it will no longer be able to invite you.',
  'Renew the account token?': 'Renew the account token?',
  'Partners who already have the current token will no longer be able to invite you. Send them the new one.': 'Partners who already have the current token will no longer be able to invite you. Send them the new one.',
  'Revoke the contract with this partner?': 'Revoke the contract with this partner?',
  'Suspend this contract?': 'Suspend this contract?',
  'Suspending hides your {0} stations in the app of {1} until you reactivate.': 'Suspending hides your {0} stations in the app of {1} until you reactivate.',
  'Suspending hides the {0} stations of {1} in your app until you reactivate.': 'Suspending hides the {0} stations of {1} in your app until you reactivate.',
  'Suspending hides your {0} stations in the app of {1}, and the {2} stations of theirs in your app, until you reactivate.': 'Suspending hides your {0} stations in the app of {1}, and the {2} stations of theirs in your app, until you reactivate.',
  'Revoking is not reversible: the stations stop being displayed on both sides, and reconnecting requires a new invite.': 'Revoking is not reversible: the stations stop being displayed on both sides, and reconnecting requires a new invite.',
  '— awaiting acceptance': '— awaiting acceptance',
  '— contract ended': '— contract ended',
  'does not receive — one-way contract': 'does not receive — one-way contract',
  '{0} stations shown in my app': '{0} stations shown in my app',
  '{0} stations received · hidden in the app': '{0} stations received · hidden in the app',
  '{0} in the invite · awaiting acceptance': '{0} in the invite · awaiting acceptance',
  '0 · contract ended': '0 · contract ended',
  'stations · {0} account': 'stations · {0} account',
  'stations · {0} accounts': 'stations · {0} accounts',
  'Turning receiving on or off does not change the contract: it only hides the partner stations in your app.': 'Turning receiving on or off does not change the contract: it only hides the partner stations in your app.',
  'Could not complete the action. Nothing was changed.': 'Could not complete the action. Nothing was changed.',
  'Contract revoked.': 'Contract revoked.',
  'Contract suspended.': 'Contract suspended.',
  'Contract reactivated.': 'Contract reactivated.',
  'Stations now visible in your app.': 'Stations now visible in your app.',
  'Stations hidden in your app.': 'Stations hidden in your app.',
  'Try again': 'Try again',
  'Could not load interoperability data.': 'Could not load interoperability data.',
  'Could not load the charges.': 'Could not load the charges.',
  'Could not load the history.': 'Could not load the history.',
  'Could not load the map.': 'Could not load the map.',
  'This tab is delivered in its own task.': 'This tab is delivered in its own task.',
  'Firmware Update History': 'Firmware Update History',
  'Search by station': 'Search by station',
  Charger: 'Charger',
  'Update date': 'Update date',
  'MCU previous version': 'MCU previous version',
  'MCU current version': 'MCU current version',
  'Initial version': 'Initial version',
  Account: 'Account',
  'Gateway previous version': 'Gateway previous version',
  'Gateway current version': 'Gateway current version',
  'Updated by': 'Updated by',
  'Remote update': 'Remote update',
  'Updates in period': 'Updates in period',
  'Last update': 'Last update',
  'Firmware History': 'Firmware History',
  'Charger / Station': 'Charger / Station',
  Period: 'Period',
  'Total records': 'Total records',
  'Update records': 'Update records',
  results: 'results',
  'No records found': 'No records found',
  Showing: 'Showing',
  of: 'of',
  Restart: 'Restart',
  // MV2-1263
  'Erro ao carregar configuração de push': 'Error loading push configuration',
  'Informe um valor maior ou igual a 1':
    'Enter a value greater than or equal to 1',
  'Limite atualizado com sucesso!': 'Limit updated successfully!',
  'Não foi possível atualizar o limite.': 'Could not update the limit.',
  'Limite de destinatários por push': 'Recipients limit per push',
  Salvar: 'Save',
  'O filtro selecionado retornou': 'The selected filter returned',
  'usuários, porém o limite máximo por envio é de':
    'users, but the maximum limit per send is',
  'destinatários. Refine os filtros da campanha ou utilize a opção de envio para todo o tenant.':
    'recipients. Narrow the campaign filters or use the send-to-whole-tenant option.',
  'A audiência': 'The audience',
  'excede o limite de': 'exceeds the limit of',
  'destinatários. Refine o filtro ou use o envio para todo o tenant.':
    'recipients. Narrow the filter or use the send-to-whole-tenant option.',
  'Excede o limite de': 'Exceeds the limit of',
  Submit: 'Submit',
  Title: 'Title',
  'Trusted user audit history': 'Trusted user change history',
  'Date/Time': 'Date/Time',
  'Previous value': 'Previous',
  'New value': 'New',
  Trusted: 'Trusted',
  'Not trusted': 'Not trusted',
  'Could not load audit history': 'Could not load audit history.',
  'Get Composite Schedule': 'Get Composite Schedule',
  '0 = charge point as a whole': '0 = charge point as a whole',
  '-- Empty --': '-- Empty --',
  'Duration (in seconds)': 'Duration (in seconds)',
  'Schedule Start': 'Schedule Start',
  'Start Schedule': 'Start Schedule',
  'Min Charging Rate': 'Min Charging Rate',
  'Start Period (in sec)': 'Start Period (in sec)',
  'Power Limit': 'Power Limit',
  'Number Phases': 'Number Phases',
  'Change statement value': 'Change statement value',
  'Add value': 'Add value',
  'Remove value': 'Remove value',
  'Value': 'Value',
  'Enter a value greater than zero': 'Enter a value greater than zero',
  'Operation type': 'Operation type',
  'The value will be added to the balance':
    'The value will be added to the balance',
  'The value will be subtracted from the balance':
    'The value will be subtracted from the balance',
  Confirm: 'Confirm',
  'Ex: 10,00': 'Ex: 10.00',
  'Balance updated successfully': 'Balance updated successfully',
  'Failed to update balance': 'Failed to update balance',
  'Wallet changed for': 'Wallet changed for',
  'Changed by': 'Changed by',
  'Failed to load': 'Failed to load',
  'Stop charging': 'Stop charging',
  'Are you sure you want to force-stop the charging?\n\nBefore continuing, try using the "Stop charging" command in Operations. By forcing the stop, the charging will be finalized with the values measured so far.':
    'Are you sure you want to force-stop the charging?\n\nBefore continuing, try using the "Stop charging" command in Operations. By forcing the stop, the charging will be finalized with the values measured so far.',
  'Charging stopped successfully!': 'Charging stopped successfully!',
  'Failed to stop charging.': 'Failed to stop charging.',
  // Interoperability tour (MV2-1791)
  'See the tour again': 'See the tour again',
  'Back': 'Back',
  'Next step': 'Next step',
  'Got it': 'Got it',
  'Skip tour': 'Skip tour',
  'What this module does': 'What this module does',
  'Interoperability lets two accounts share the visibility of their stations. The tabs follow the order of the process, left to right, and this tour walks through them in that order.': 'Interoperability lets two accounts share the visibility of their stations. The tabs follow the order of the process, left to right, and this tour walks through them in that order.',
  'Eligibility is the gate': 'Eligibility is the gate',
  'Nothing else works before this: the account and the sub-accounts you choose need to be eligible to bind. Turning it on opens data replication to the interoperability service, which is why it is behind its own permission.': 'Nothing else works before this: the account and the sub-accounts you choose need to be eligible to bind. Turning it on opens data replication to the interoperability service, which is why it is behind its own permission.',
  'An accepted invite becomes a contract': 'An accepted invite becomes a contract',
  'Here are the contracts already in force, with who and in which direction. Bidirectional means both sides see each other — it depends on the partner having an app of their own. One-way means only one side sees. The same contracts also show as a map of links.': 'Here are the contracts already in force, with who and in which direction. Bidirectional means both sides see each other — it depends on the partner having an app of their own. One-way means only one side sees. The same contracts also show as a map of links.',
  'What the contract delivers': 'What the contract delivers',
  'The stations the contract made visible to you, and the ones you made visible to the partner. This is the tab that shows the result of everything above.': 'The stations the contract made visible to you, and the ones you made visible to the partner. This is the tab that shows the result of everything above.',
  'Charges across accounts': 'Charges across accounts',
  'Charging sessions your drivers ran on partner stations, and the ones partner drivers ran on yours.': 'Charging sessions your drivers ran on partner stations, and the ones partner drivers ran on yours.',
  'Who changed what': 'Who changed what',
  'Every change to eligibility, invites and contracts, with author and date. Use it to answer why a partner stopped seeing your stations.': 'Every change to eligibility, invites and contracts, with author and date. Use it to answer why a partner stopped seeing your stations.',
  'For whoever integrates a system': 'For whoever integrates a system',
  'Account settings, not day-to-day operation: the access key and the endpoint documentation, for reading this same data from outside the dashboard.': 'Account settings, not day-to-day operation: the access key and the endpoint documentation, for reading this same data from outside the dashboard.',
  // Interoperability tour - fluxo de convite (MV2-1791)
  'Tutorial': 'Tutorial',
  'Invite and token flow': 'Invite and token flow',
  'First, your account token': 'First, your account token',
  'This token is the address of your account: you hand it to a partner so they are able to invite you. It is not the invite itself — it can be shown again and renewed whenever you want, and whoever holds it can only invite you. Accepting is always your own act.': 'This token is the address of your account: you hand it to a partner so they are able to invite you. It is not the invite itself — it can be shown again and renewed whenever you want, and whoever holds it can only invite you. Accepting is always your own act.',
  'Inviting starts with the partner token': 'Inviting starts with the partner token',
  'Ask the partner for the token on their own Interoperability screen, paste it here and check it. The check tells you whether that account has an app configured: with no app it does not display stations, so only the one-way contract is possible. Then you pick which of your accounts enter the contract and how long the invite stays valid.': 'Ask the partner for the token on their own Interoperability screen, paste it here and check it. The check tells you whether that account has an app configured: with no app it does not display stations, so only the one-way contract is possible. Then you pick which of your accounts enter the contract and how long the invite stays valid.',
  'The invite token is a different one': 'The invite token is a different one',
  'Generating the invite produces a second token: single use, shown only once and kept only as a hash, so it cannot be recovered. Send it to the partner through a safe channel. On the receiving side it is pasted right here, in "Enter token", where the summary says how many accounts and stations the contract shares before it is authorized.': 'Generating the invite produces a second token: single use, shown only once and kept only as a hash, so it cannot be recovered. Send it to the partner through a safe channel. On the receiving side it is pasted right here, in "Enter token", where the summary says how many accounts and stations the contract shares before it is authorized.',
  'A received invite waits here': 'A received invite waits here',
  'When someone invites you, the notice shows up at the top of the screen with the time left, and "Review invite" opens the acceptance straight away — no need to hunt for the token in your e-mail.': 'When someone invites you, the notice shows up at the top of the screen with the time left, and "Review invite" opens the acceptance straight away — no need to hunt for the token in your e-mail.',
  'Every invite, in both directions': 'Every invite, in both directions',
  'The ones you sent and the ones you received, with what became of each: pending, used, expired or revoked. A pending invite can still be revoked; an expired one cannot be reused, and connecting that partner takes a new invite.': 'The ones you sent and the ones you received, with what became of each: pending, used, expired or revoked. A pending invite can still be revoked; an expired one cannot be reused, and connecting that partner takes a new invite.',
  'This module is not available for your account.': 'This module is not available for your account.',
  'Your account does not have access to this area. Talk to the administrator if you need it.': 'Your account does not have access to this area. Talk to the administrator if you need it.',
  'Back to home': 'Back to home',
  'There is already an active invite for this partner. To generate a new one, revoke the previous one on the Invites tab.': 'There is already an active invite for this partner. To generate a new one, revoke the previous one on the Invites tab.',
  'Do not charge idle time': 'Do not charge idle time',
  'Idle charging 24 hours': 'Charge idle time 24 hours',
  'Customize idle exemption per day': 'Customize exemption per day',
  'Charge idle time all day': 'Charge idle time all day',
  'Idle exemption description': 'Set the time windows in which idle time will not be charged, per day of week',
  'Idle exemption always charge empty state': 'Idle time is charged 24 hours a day, every day',
  'Idle exemption inactive empty state': 'Turn on "Customize per day" to configure different windows for each day',
  'Idle exemption hint prefix': 'From',
  'Idle exemption hint separator': 'to',
  'Idle exemption hint suffix': 'idle time will not be charged',
  'Use custom idle exemption per connector': 'Use custom schedule (otherwise inherits from station)',
  'Per-connector idle exemption overrides': 'Per-connector idle exemption overrides',
  'Idle exemption periods overlap': 'Windows overlap on the same day',
  'Approve manually': 'Approve manually',
  'Charge wallet': 'Charge wallet',
  'Charge credit card': 'Charge credit card',
  'Confirm manual approval?': 'Confirm manual approval?',
  'Manual approval description':
    'The transaction will be marked as manually paid. This action will be recorded in the audit log.',
  'Confirm card charge?': 'Confirm card charge?',
  'Card charge description':
    'We will try to capture the existing pre-authorization. If not possible, a new charge will be made. Continue?',
  'Charge wallet title': 'Charge wallet',
  'Wallet balance insufficient':
    'Insufficient balance (missing R$ {value}). Wallet charge is blocked.',
  'Wallet with open pre-auth':
    'There is an open pre-authorization on the customer\'s card. Upon confirmation, it will be cancelled.',
  'Manual action success': 'Operation completed successfully',
  'Manual action failure': 'Operation failed',
  'Charge succeeded': 'Charge completed successfully',
  'Wallet charged but pre-auth cancel failed': 'Wallet charge succeeded but pre-auth cancel failed. Check and cancel manually in PagBank.',
  'Approved manually': 'Payment approved manually',
  'Card charged': 'Card charge approved',
  // M24: labels for WalletChargeConfirmationModal
  Balance: 'Balance',
  Amount: 'Amount',
  // MV2-1609 — agendamento de push (aba Agendados, bloco "Quando enviar" e modal de
  // edição). As chaves são o texto em português usado no codigo.
  'Agendados': 'Scheduled',
  'Agendar': 'Schedule',
  'Agendar envio': 'Schedule send',
  'Agendamento atualizado com sucesso': 'Schedule updated successfully',
  'Agendamento cancelado': 'Schedule cancelled',
  'Ações': 'Actions',
  'A data-fim precisa ser depois do primeiro disparo': 'The end date must be after the first send',
  'Cancelar': 'Cancel',
  'Cancelar agendamento': 'Cancel schedule',
  'Cancelar agendamento?': 'Cancel schedule?',
  'Data do disparo': 'Send date',
  'Data/hora': 'Date/time',
  'Destinatários': 'Recipients',
  'Disparo imediato para os destinatários': 'Immediate send to the recipients',
  'Editar': 'Edit',
  'Editar agendamento': 'Edit schedule',
  'Em meses que não têm o dia escolhido, o disparo cai no último dia do mês: 31/01 vira 28/02.':
    'In months without the chosen day, the send falls on the last day of the month: 31/01 becomes 28/02.',
  'Enviar agora': 'Send now',
  'Erro ao carregar agendamentos': 'Failed to load schedules',
  'Escolha data e hora do disparo': 'Choose the send date and time',
  'Este agendamento já foi processado e não pode mais ser cancelado.':
    'This schedule has already been processed and can no longer be cancelled.',
  'Este agendamento já foi processado e não pode mais ser editado.':
    'This schedule has already been processed and can no longer be edited.',
  'Este agendamento não existe mais. Atualize a lista.':
    'This schedule no longer exists. Refresh the list.',
  'Fuso horário': 'Time zone',
  'Hora do disparo': 'Send time',
  'Informe a data do disparo': 'Enter the send date',
  'Informe a hora do disparo': 'Enter the send time',
  'Informe até quando repetir': 'Enter until when to repeat',
  'Mensagem': 'Message',
  'Nenhum push agendado': 'No scheduled push',
  'Não foi possível agendar o push. Tente novamente.': 'Could not schedule the push. Try again.',
  'Não foi possível cancelar o agendamento. Tente novamente.':
    'Could not cancel the schedule. Try again.',
  'Não foi possível salvar o agendamento. Tente novamente.':
    'Could not save the schedule. Try again.',
  'Não foi possível salvar: verifique os campos preenchidos.':
    'Could not save: check the fields you filled in.',
  'Não repetir': 'Do not repeat',
  'O campo mensagem é obrigatório.': 'The message field is required.',
  'O campo título é obrigatório.': 'The title field is required.',
  'O disparo precisa ser no futuro': 'The send must be in the future',
  'O serviço de agendamento não está disponível no momento. Avise o suporte.':
    'The scheduling service is unavailable right now. Contact support.',
  'Por Região': 'By Region',
  'Por Usuário': 'By User',
  'Push': 'Push',
  'Push agendado com sucesso': 'Push scheduled successfully',
  'Push Notification em processamento. Acompanhe o resultado na aba Histórico.': 'Push Notification is being processed. Follow the result in the History tab.',
  'Quando enviar': 'When to send',
  'Repetir até': 'Repeat until',
  'Repetição': 'Recurrence',
  'Se houver repetição,': 'If there is a recurrence,',
  'Título': 'Title',
  'Toda semana': 'Every week',
  'Todo mês': 'Every month',
  'Todos': 'All',
  'Voltar': 'Back',
  'até': 'until',
  'registros': 'records',
  'serão canceladas. Essa ação não pode ser desfeita.':
    'will be cancelled. This action cannot be undone.',
  'todas as ocorrências futuras': 'all future occurrences',
  'usuários': 'users',
  'Audit Log': 'Audit Log',
  'Change history in the system': 'History of changes made in the system',
  'Change type': 'Change type',
  'What changed': 'What changed',
  'Where': 'Where',
  'Changes in period': 'Changes in period',
  'Last change': 'Last change',
  'Audit records': 'Audit records',
  'All types': 'All types',
  'Filter': 'Filter',
  'Clear': 'Clear',
  'Record details': 'Record details',
  'View details': 'View details',
  'Could not load the audit records': 'Could not load the audit records',
  'Could not load the change types': 'Could not load the change types',
  'Trusted user': 'Trusted user',
  'User document': 'User document',
  'Wallet balance': 'Wallet balance',
  'Manual charge stop': 'Manual charge stop',
  'Charger type': 'Charger type',
  'Charger firmware': 'Charger firmware',
  'Station edit': 'Station edit',
  'Price profile edit': 'Price profile edit',
  'Advanced configuration edit': 'Advanced configuration edit',
  'Connector door opening': 'Connector door opening',
  'Access door': 'Access door',
  Connector: 'Connector',
  Unspecified: 'Unspecified',
  'Door disabled': 'Disabled',
  'Door not configured': 'Not configured',
  Configured: 'Configured',
  'Each connector has its own door.': 'Each connector has its own door.',
  'Could not load the door settings.': 'Could not load the door settings.',
  'Discard changes?': 'Discard changes?',
  'The changes to this connector have not been saved.': 'The changes to this connector have not been saved.',
  Discard: 'Discard',
  'This connector has door unlock': 'This connector has door unlock',
  'When enabled, enables remote opening settings and the unlock button in the driver app': 'When enabled, enables remote opening settings and the unlock button in the driver app',
  'How it opens': 'How it opens',
  'Opening method': 'Opening method',
  'HTTP call (webhook)': 'HTTP call (webhook)',
  'Opening is always triggered by someone, from the button in the app or from the dashboard, never by a reader on the equipment.': 'Opening is always triggered by someone, from the button in the app or from the dashboard, never by a reader on the equipment.',
  'HTTP call': 'HTTP call',
  Timeout: 'Timeout',
  '{0} s (system default)': '{0} s (system default)',
  'Test connection': 'Test connection',
  'Open door now': 'Open door now',
  'Save your changes before opening the door.': 'Save your changes before opening the door.',
  'Last opening': 'Last opening',
  'No opening recorded.': 'No opening recorded.',
  'Last 10 openings': 'Last 10 openings',
  View: 'View',
  Close: 'Close',
  'Could not load the opening history.': 'Could not load the opening history.',
  'Driver app': 'Driver app',
  Dashboard: 'Dashboard',
  'Door settings saved.': 'Door settings saved.',
  'Check the highlighted fields.': 'Check the highlighted fields.',
  'Open the door now?': 'Open the door now?',
  'This will unlock the access door of this connector.': 'This will unlock the access door of this connector.',
  'Open door': 'Open door',
  'Unsaved changes do not apply to this opening.': 'Unsaved changes do not apply to this opening.',
  'The settings on screen will be used for this opening, without saving.': 'The settings on screen will be used for this opening, without saving.',
  'The access door of connector {0} was not saved: {1}': 'The access door of connector {0} was not saved: {1}',
  'Copy from connector {0}': 'Copy from connector {0}',
  'No attempt in this session': 'No attempt in this session',
  'Request failed': 'Request failed',
  'Timed out': 'Timed out',
  'Network error': 'Network error',
  'Enter the controller URL': 'Enter the controller URL',
  Headers: 'Headers',
  Key: 'Key',
  'Description (optional)': 'Description (optional)',
  'JSON body': 'Message body',
  'Enter the request body in JSON': 'Enter the request body in JSON',
  'Variables:': 'Variables:',
  'The URL field is mandatory.': 'The URL field is mandatory.',
  'The URL must start with http:// or https://.': 'The URL must start with http:// or https://.',
  'The body is not valid JSON.': 'The body is not valid JSON.',
  'The header key is mandatory.': 'The header key is mandatory.',
  'The header value is mandatory.': 'The header value is mandatory.',
  'HTTP method': 'HTTP method',
  'Controller URL': 'Controller URL',
  'Door settings saved, but the status could not be refreshed.': 'Door settings saved, but the status could not be refreshed.',
  'The door was triggered, but the last opening could not be refreshed.': 'The door was triggered, but the last opening could not be refreshed.',
  'Unexpected code {0}': 'Unexpected code {0}',
  'Test sent: {0}': 'Test sent: {0}',
  'Door opened: {0}': 'Door opened: {0}',
  'Test failed: {0}': 'Test failed: {0}',
  'Opening failed: {0}': 'Opening failed: {0}',
  'Connection checked in {0} ms.': 'Connection checked in {0} ms.',
  'Synchronous call completed in {0} ms.': 'Synchronous call completed in {0} ms.',
  'Remove header': 'Remove header',
  Save: 'Save',
  'Door enabled': 'Enabled',
  'Door unlock is not configured for this connector': 'Door unlock is not configured for this connector',
  'URL is required': 'URL is required',
  'URL must start with http:// or https://': 'URL must start with http:// or https://',
  'Body is not a valid JSON': 'Body is not a valid JSON',
  'Header key is required': 'Header key is required',
  'Header value is required': 'Header value is required',
  'Header key has invalid characters': 'Header key has invalid characters',
  'Header value has invalid characters': 'Header value has invalid characters',
  'Charge point not found': 'Charge point not found',
  'Connector not found': 'Connector not found',
  'Invalid URL': 'Invalid URL',
  'Invalid header': 'Invalid header',
  'Destination not allowed': 'Destination not allowed',
  'Call interrupted': 'Call interrupted',
  'The controller did not respond in time': 'The controller did not respond in time',
  'Device ID': 'Device ID',
  'Enter the controller DEVICE_ID': 'Enter the controller DEVICE_ID',
  'The Device ID field is mandatory.': 'The Device ID field is mandatory.',
  "The Device ID may only have letters, digits, '_' and '-'.": "The Device ID may only have letters, digits, '_' and '-'.",
  'The body is mandatory.': 'The body is mandatory.',
  'Unexpected response': 'Unexpected response',
  'Device ID is required': 'The Device ID is required.',
  "Device ID may only have letters, digits, '_' and '-'": "The Device ID may only have letters, digits, '_' and '-'.",
  'Body is required': 'The body is required.',
  'RabbitMQ is disabled on this server': 'RabbitMQ is disabled on this server.',
  'Could not reach the message broker': 'Could not reach the message broker.',
  'Could not connect to the controller': 'Could not connect to the controller',
  'Too many door calls at the same time, try again in a moment': 'Too many calls at the same time. Try again in a moment.',
  'A door opening is already in progress for this connector': 'A door opening is already in progress for this connector.',
  // MV2-1974 módulo OCPI
  'Address': 'Address',
  'All': 'All',
  'All charges made at the stations published via OCPI, by partner users or not. The partner of each charge is not identified.': 'All charges made at the stations published via OCPI, by partner users or not. The partner of each charge is not identified.',
  'All states': 'All states',
  'All statuses': 'All statuses',
  'Amount': 'Amount',
  'Available': 'Available',
  'Average duration': 'Average duration',
  'Back': 'Back',
  'Billed in the period': 'Billed in the period',
  'Blocked': 'Blocked',
  'CDR': 'CDR',
  'CDR available': 'CDR available',
  'CDR of charge': 'CDR of charge',
  'CDRs in the period': 'CDRs in the period',
  'Charge': 'Charge',
  'Charge data': 'Charge data',
  'Charges': 'Charges',
  'Charges at this station in the period': 'Charges at this station in the period',
  'Charges in progress': 'Charges in progress',
  'Charging': 'Charging',
  'Check whether the partner has already sent the token.': 'Check whether the partner has already sent the token.',
  'City': 'City',
  'Completed': 'Completed',
  'Connector': 'Connector',
  'Connector status now': 'Connector status now',
  'Connectors': 'Connectors',
  'Coordinates': 'Coordinates',
  'Could not load the OCPI data. Try again in a few minutes.': 'Could not load the OCPI data. Try again in a few minutes.',
  'Could not look up the token. Try again in a few minutes.': 'Could not look up the token. Try again in a few minutes.',
  'Currency': 'Currency',
  'Duration': 'Duration',
  'E.g.: 04A2B7719C81': 'E.g.: 04A2B7719C81',
  'End': 'End',
  'Ended': 'Ended',
  'Ended without consumption': 'Ended without consumption',
  'Energy': 'Energy',
  'Energy in the period': 'Energy in the period',
  'Enter the UID of the token the partner sent to see the linked tag in the CS.': 'Enter the UID of the token the partner sent to see the linked tag in the CS.',
  'Error reported by the station': 'Error reported by the station',
  'Faulted': 'Faulted',
  'Finishing': 'Finishing',
  'Generated when it ends': 'Generated when it ends',
  'Idle fee': 'Idle fee',
  'In OCPI, each connector is published as an EVSE.': 'In OCPI, each connector is published as an EVSE.',
  'In progress': 'In progress',
  'In use': 'In use',
  'Inoperative': 'Inoperative',
  'Invalid': 'Invalid',
  'Invalid charges do not generate a CDR': 'Invalid charges do not generate a CDR',
  'Last 30 days': 'Last 30 days',
  'Last 7 days': 'Last 7 days',
  'List': 'List',
  'Location': 'Location',
  'Location (address_pk)': 'Location (address_pk)',
  'Look up': 'Look up',
  'Look up OCPI token': 'Look up OCPI token',
  'Look up token': 'Look up token',
  'Map': 'Map',
  'No CDR': 'No CDR',
  'No CDRs in the period.': 'No CDRs in the period.',
  'No OCPI token with the UID': 'No OCPI token with the UID',
  'No charges at this station in the period.': 'No charges at this station in the period.',
  'No charges in the period.': 'No charges in the period.',
  'No fee': 'No fee',
  'No photos': 'No photos',
  'No station is marked as OCPI compatible in this account yet.': 'No station is marked as OCPI compatible in this account yet.',
  'No station with these filters.': 'No station with these filters.',
  'OCPI UID': 'OCPI UID',
  'Out of order': 'Out of order',
  'Overview': 'Overview',
  'Pending': 'Pending',
  'Per kWh': 'Per kWh',
  'Per minute': 'Per minute',
  'Period (start date)': 'Period (start date)',
  'Photos': 'Photos',
  'Planned': 'Planned',
  'Preparing': 'Preparing',
  'Public': 'Public',
  'Published stations': 'Published stations',
  'Recent charges': 'Recent charges',
  'Registered on': 'Registered on',
  'Removed': 'Removed',
  'Reservation': 'Reservation',
  'Reserved': 'Reserved',
  'Showing the first': 'Showing the first',
  'Start': 'Start',
  'Start → end': 'Start → end',
  'Started': 'Started',
  'Station': 'Station',
  'Station ID': 'Station ID',
  'Station ID, UUID, address or city': 'Station ID, UUID, address or city',
  'Stations': 'Stations',
  'Stations published via OCPI and the charges made on them.': 'Stations published via OCPI and the charges made on them.',
  'Stations with the most energy in the period': 'Stations with the most energy in the period',
  'Status': 'Status',
  'Suspended by station': 'Suspended by station',
  'Suspended by vehicle': 'Suspended by vehicle',
  'Tag': 'Tag',
  'Tag in the CS': 'Tag in the CS',
  'Timeline': 'Timeline',
  'Today': 'Today',
  'Token UID': 'Token UID',
  'Total': 'Total',
  'Type': 'Type',
  'Unavailable': 'Unavailable',
  'Unknown': 'Unknown',
  'Updated on': 'Updated on',
  'View CDR': 'View CDR',
  'View charge': 'View charge',
  'View station': 'View station',
  'Waiting to start': 'Waiting to start',
  'charges': 'charges',
  'connectors': 'connectors',
  'ongoing': 'ongoing',
  'Connector faulted': 'Faulted',
  'Connector finishing': 'Finishing',
  'Connector unavailable': 'Unavailable',
  'Charge period': 'Period',
  'since': 'since',
  'started in the period': 'started in the period',
  'stations': 'stations',
  'up to': 'up to',
  'with a faulted or unavailable connector': 'with a faulted or unavailable connector',
  // MV2-1974 módulo OCPI: recebidas como parceiro
  'Received as partner': 'Received as partner',
  'Could not load the stations received as a partner.': 'Could not load the stations received as a partner.',
  'This account has no external id in the cross, so it does not receive stations as a partner.': 'This account has no external id in the cross, so it does not receive stations as a partner.',
  'Stations this account receives as a partner (eMSP) through the bindings in the cross. It is the same list the OCPI service uses to build the partner /locations.': 'Stations this account receives as a partner (eMSP) through the bindings in the cross. It is the same list the OCPI service uses to build the partner /locations.',
  'Account in the cross': 'Account in the cross',
  'external id': 'external id',
  'Stations received': 'Stations received',
  'operators': 'operators',
  'Go into the feed': 'Go into the feed',
  'with address, coordinates and operator': 'with address, coordinates and operator',
  'Discarded by the OCPI': 'Discarded by the OCPI',
  'never reach the partner': 'never reach the partner',
  'The cross returned more pages than the dashboard reads. Only the first ones are shown.': 'The cross returned more pages than the dashboard reads. Only the first ones are shown.',
  'No station is bound to this account as a partner.': 'No station is bound to this account as a partner.',
  'By operator': 'By operator',
  'Operator': 'Operator',
  'Feed': 'Feed',
  'Discarded': 'Discarded',
  'Goes into the feed': 'Goes into the feed',
  'No operator name': 'No operator name',
  'No address': 'No address',
  'No coordinates': 'No coordinates',
  'Click an operator to see only its stations.': 'Click an operator to see only its stations.',
  'Search operator': 'Search operator',
  'No operator with this name.': 'No operator with this name.',
  'Station code, description, address or city': 'Station code, description, address or city',
  'All operators': 'All operators',
  'Stations this account sends and receives via OCPI, and the charges made on the ones it sends.': 'Stations this account sends and receives via OCPI, and the charges made on the ones it sends.',
  'Sent stations': 'Sent stations',
  'Received stations': 'Received stations',
  'This account does not receive stations as a partner.': 'This account does not receive stations as a partner.',
  'go into the feed': 'go into the feed',
  'discarded': 'discarded',
  'Sending': 'Sending',
  'Stations of this account that the partners see': 'Stations of this account that the partners see',
  'with a faulted connector': 'with a faulted connector',
  'View sent stations': 'View sent stations',
  'Receiving': 'Receiving',
  'Stations of other operators bound to this account in the cross': 'Stations of other operators bound to this account in the cross',
  'View received stations': 'View received stations',
  'Charges at the stations this account sends': 'Charges at the stations this account sends',
  'Receiving as partner (eMSP)': 'Receiving as partner (eMSP)',
  'Stations of other operators bound to this account in the cross. It is the same list the OCPI service uses to build the partner /locations.': 'Stations of other operators bound to this account in the cross. It is the same list the OCPI service uses to build the partner /locations.',
  'Green goes into the feed, red is discarded by the OCPI. Stations without coordinates do not appear on the map.': 'Green goes into the feed, red is discarded by the OCPI. Stations without coordinates do not appear on the map.',
  'Sending as operator (CPO)': 'Sending as operator (CPO)',
  'Stations of this account that the OCPI service publishes to the partners: public and marked as OCPI compatible.': 'Stations of this account that the OCPI service publishes to the partners: public and marked as OCPI compatible.',
  'Why the OCPI discards it': 'Why the OCPI discards it',
  'Open in Google Maps': 'Open in Google Maps',
  'Close': 'Close',
  'Online': 'Online',
  'Offline': 'Offline',
  'Reason': 'Reason',
  'The OCPI service leaves this station out of the partner /locations until the data is fixed in the operator account.': 'The OCPI service leaves this station out of the partner /locations until the data is fixed in the operator account.',
  'The partner receives this station in /locations. In OCPI, each connector is published as an EVSE.': 'The partner receives this station in /locations. In OCPI, each connector is published as an EVSE.',
  'Connection': 'Connection',
  'No connector registered.': 'No connector registered.',
  'Description': 'Description',
  'The partners receive this station in /locations. In OCPI, each connector is published as an EVSE.': 'The partners receive this station in /locations. In OCPI, each connector is published as an EVSE.',
  'ZIP code': 'ZIP code',
  'Since': 'Since',
  'Power': 'Power',
  // OCPI: chave própria, a 'Power' global diz (W) e a potência do conector é exibida em kW.
  'Connector power': 'Power',
  'Showing only': 'Showing only',
  'Minimized. Expand to filter by operator.': 'Minimized. Expand to filter by operator.',
  'Expand': 'Expand',
  'Minimize': 'Minimize',
  'Sending and receiving': 'Sending and receiving',
  Tickets: 'Tickets',
  'Tickets (Internal)': 'Tickets (Internal)',
  'You do not have access to this area': 'You do not have access to this area',
  'Open ticket': 'Open ticket',
  'Open tickets': 'Open',
  'Resolved tickets': 'Resolved',
  'Filter by company': 'Filter by company',
  'Tickets are not configured for your company yet': 'Tickets are not configured for your company yet',
  'Could not load tickets': 'Could not load tickets',
  'No tickets yet': 'No tickets yet',
  'Medium priority': 'Medium',
  'Load more': 'Load more',
  'File type not allowed': 'File type not allowed',
  'File too large (max 10 MB)': 'File too large (max 10 MB)',
  'Required field': 'Required field',
  'Ticket created': 'Ticket created',
  'Ticket review step': 'Review',
  'Choose a request type': 'Choose a request type',
  'Which company is this ticket about?': 'Which company is this ticket about?',
  'My own company (default)': 'My own company (default)',
  'Could not load request types': 'Could not load request types',
  'Could not load form fields': 'Could not load form fields',
  'Upload failed': 'Upload failed',
  'Could not create the ticket': 'Could not create the ticket',
  'Remove': 'Remove',
  'Uploading': 'Uploading',
  'Messages': 'Messages',
  'Write a reply': 'Write a reply',
  'Could not load the ticket': 'Could not load the ticket',
  'Could not send the message': 'Could not send the message',
  'Ticket management — Move internal': 'Ticket management — Move internal',
  'SLA at risk': 'SLA at risk',
  'Resolved today': 'Resolved today',
  'Most frequent types': 'Most frequent types',
  'Tickets by company': 'Tickets by company',
  'Monthly volume': 'Monthly volume',
  'Company': 'Company',
  'Priority': 'Priority',
  'Assignee': 'Assignee',
  'Refresh types': 'Refresh types',
  'Ticket': 'Ticket',
  'Internal note': 'Internal note',
  'Agent account id': 'Agent account id',
  'Assign': 'Assign',
  'Invalid agent account id': 'Invalid agent account id',
  'Could not change the status': 'Could not change the status',
  'Could not assign the ticket': 'Could not assign the ticket',
  'Only visible to Move': 'Only visible to Move',
  'Totals are global and not affected by the filters': 'Totals are global and not affected by the filters',
  'No data': 'No data',
  'Could not refresh the types': 'Could not refresh the types',
  'Critical priority': 'Critical',
  'High priority': 'High',
  'Low priority': 'Low',
  'Based on the loaded list': 'Based on the loaded list',
  'Opened on behalf of': 'Opened on behalf of',
  'Could not load the status changes': 'Could not load the status changes',
  'Reply to customer': 'Reply to customer',
  'Internal note (only visible to Move)': 'Internal note (only visible to Move)',
  'The ticket may have been created but could not be linked to your company. Do not try again; contact support.': 'The ticket may have been created but could not be linked to your company. Do not try again; contact support.',
  // MV2-1952
  'Enter a valid e-mail, for example name@email.com':
    'Enter a valid e-mail, for example name@email.com',
};

export default locale;
